/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getSistemas } from "../../services/SistemaService";
import { saveSistemaRol } from "../../services/SistemaRolService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  idSistema: null,
  descripcion: "",
  codigo: "",
  observaciones: "",
};

const itemGender = "M";
const nameItemText = "Rol de Sistema";
//
// #####################################################################################################################
//
const SistemaRolDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACSistemas, setValueACSistemas] = useState({});
  const [inputValueACSistemas, setInputValueACSistemas] = useState("");
  const [sistemas, setSistemas] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadSistemas();

    if (actionCrud === "new") {
      setValueACSistemas(sistemas[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueACSistemas(itemCrud.sistema);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (!inputValueACSistemas) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Sistema",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcion) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar una descripción del Rol",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.codigo) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el código del Rol",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ################################################################################
  //
  const save = async () => {
    let _itemCrud = {
      id_sistema: valueACSistemas.id,
      descripcion: itemCrudLocal.descripcion,
      codigo: itemCrudLocal.codigo,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveSistemaRol(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadSistemas = async () => {

    setIsDoingSomething(true);
    const response = await getSistemas();
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _sistemas = [];
      _response.forEach((item) => {
        _sistemas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSistemas(_sistemas);
    } else {
      setSistemas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <Autocomplete
                id="sistema"
                sx={{ width: "100%" }}
                size="small"
                value={valueACSistemas ?? null}
                onChange={(event, newValue) => {
                  setValueACSistemas(newValue);
                }}
                inputValue={inputValueACSistemas}
                onInputChange={(event, newInputValue) => {
                  setInputValueACSistemas(newInputValue);
                }}
                options={sistemas}
                renderInput={(params) => <TextField {...params} label="Sistema" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                name="descripcion"
                label="Descripción"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                sx={{ width: "100%" }}
                inputProps={{ maxLength: 80 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                name="codigo"
                label="Código"
                value={itemCrudLocal.codigo}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                sx={{ width: "100%" }}
                inputProps={{ maxLength: 80 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default SistemaRolDialog;
